import { Box, Button, Typography } from '@mui/material';
import React, {useState} from 'react';
import { ControlPointOutlined, FilterAltOutlined } from '@mui/icons-material';
import DashboardReportTable from '../../organism/Dashboard.ReportTable/Dashboard.ReportTable';
import { useNavigate, useParams } from 'react-router-dom';
import { RouteKey } from '../../../App.Routes';
import CommonPageBaseLayout from '../../organism/Common.PageBaseLayout/Common.PageBaseLayout';
import FilterDropdown from './Filter.Dropdown';
import {ReportStatus} from "../../../utils/graphql/generatedTS/graphql";


/**
 *
 * @param {React.PropsWithChildren<IDashboard>} props
 * @return {JSX.Element}
 * @constructor
 */
export interface FilterValues {

    startDate?: number;
    endDate?: number;
    campaignName?: string;
    status?: ReportStatus;
}
const Dashboard: React.FC<IDashboard> = (props) => {
    const navigate = useNavigate();
    const {idTeam} = useParams();

    // Add this state for filters
    const [filters, setFilters] = useState<FilterValues>({

        startDate: undefined,
        endDate: undefined,
        campaignName: undefined,
        status: undefined,
    });

    // Add this handler function
    const handleApplyFilters = (newFilters: FilterValues) => {
        setFilters(newFilters);
    };


    return (
        <CommonPageBaseLayout>
            <Typography variant={"h1"} fontWeight={600}>
                Reports
            </Typography>
            <Typography variant={"subtitle1"} mt={1}>
                Consult and filter the list of reports. Process a new report through the <strong>New report</strong> button. Explore all the available actions by clicking on the three horizontal dots into the <strong>Actions</strong> column.
            </Typography>


            {/* row of filter / new report button*/}
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                <Box display="flex" alignItems="center">
                    <FilterDropdown onApplyFilters={handleApplyFilters} />
                </Box>
                <Button
                    variant="contained"
                    onClick={() => navigate(RouteKey.NewReport.replace(":idTeam", idTeam as string))}
                    startIcon={<ControlPointOutlined />}
                    style={{
                        fontWeight: 'bold',
                        fontSize: '14px',
                        backgroundImage: 'linear-gradient(to right, #8A5FFD, #5EE0E6)',
                    }}
                >
                    New report
                </Button>
            </Box>



            {/* Table section */}
            <Box mt={4}>
                <DashboardReportTable filters={filters}/>
            </Box>
        </CommonPageBaseLayout>
    );
};


export interface IDashboard {


}


export default Dashboard;
